import { Link } from "@material-ui/core";
import React from "react";
import "./FooterComponentBlock.scss";
import translate from "../../../i18n/translate";
import { useSelector } from "react-redux";
const FooterComponentBlock: React.FC = () => {
  const allInfo = useSelector((state: any) => state);

  const getCurrentYear = () => {
    return new Date() ? (new Date().getFullYear() || "-") : "--";
  }

  return (
    <React.Fragment>
      {allInfo.common.isUserAuthenticated ? (
        <div className="Footer-Container">
          <div className="FooterStyle">
            <span className="HeaderDate">
              <Link href="https://www.learnship.com/us/" target="_blank"><img
                className="footerlogo"
                src={window.location.origin + "/images/logos/Learnship-main-logo.svg"}
                alt="Learnship logo"
                title="Learnship footer logo"                
              /></Link>
            </span>
            <div className="Footer_redirections">
              <span className="HeaderLinks">
                <Link href="https://www.learnship.com/en/about-learnship/" target="_blank">{translate("about")}</Link>{" "}
              </span>

              <span className="HeaderLinks">
                <Link href="https://www.learnship.com/us/legal-notice/" target="_blank">{translate("legal")}</Link>{" "}
              </span>

              <span className="HeaderLinks">
                <Link href="https://www.learnship.com/us/privacy-notice/" target="_blank">{translate("privacy_policy")}</Link>{" "}
              </span>

              <span className="HeaderLinks">
                <Link href="https://www.learnship.com/us/general-terms-and-conditions/" target="_blank">
                {translate("Terms_conditions")}
                </Link>{" "}
              </span>
            </div>
            <div className="social-icons">
              © 2010 - {getCurrentYear()}
              </div>
          </div>
        </div>
      ) : (
          <div className="Footer-Container">
            <div className="FooterStyle">
              <span className="HeaderDate">
                <Link href="https://www.learnship.com/us/"><img
                  className="footerlogo"
                  src={window.location.origin + "/images/logos/Learnship-main-logo.svg"}
                  alt="Learnship logo"
                  title="Learnship footer logo"
                /></Link>
              </span>
              <div className="Footer_redirections">
                  <span className="HeaderLinks">
                    <Link href="https://www.learnship.com/en/about-learnship/" target="_blank">{translate("about")}</Link>{" "}
                  </span>

                  <span className="HeaderLinks">
                    <Link href="https://www.learnship.com/us/legal-notice/" target="_blank">{translate("legal")}</Link>{" "}
                  </span>

                  <span className="HeaderLinks">
                    <Link href="https://www.learnship.com/us/privacy-notice/" target="_blank">{translate("privacy_policy")}</Link>{" "}
                  </span>

                  <span className="HeaderLinks">
                    <Link href="https://www.learnship.com/us/general-terms-and-conditions/" target="_blank">
                    {translate("Terms_conditions")}
                    </Link>{" "}
                  </span>
                {/* <span className="HeaderLinks">
                  <Link href="http://beian.miit.gov.cn" target="_blank">
                    沪ICP备14032085号-1
                </Link>
                </span> */}
              </div>
              <div className="social-icons">
                © 2010 - {getCurrentYear()}                
              </div>
            </div>
          </div>
        )}
    </React.Fragment>
  );
};

export default FooterComponentBlock;
